import { getCookie, refreshSession, Z_SESSION_COOKIE_KEY } from '@zoomit/primitives';

import { StoreLink } from '../constants/apis';

type Params = {
  url: string;
  storeLinkId: string;
  storeId: string;
  price: number;
  position?: string;
  referrer: string;
};

export const getStoreLink = ({ url, price, storeId, storeLinkId, position, referrer }: Params) => {
  const outOfStock = price === 0 ? 'true' : 'false';

  refreshSession();

  const searchParams = {
    url,
    sessionId: getCookie(Z_SESSION_COOKIE_KEY),
    outOfStock,
    storeId,
    position,
    referrer,
  };

  const addr = new URL(`${StoreLink}/${storeLinkId}/click`);
  for (const [key, value] of Object.entries(searchParams)) {
    value && addr.searchParams.append(key, value!);
  }

  return addr.toString();
};
